import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useSectionProfile from "./hooks/useSectionProfile";

import SectionHeader from "./components/SectionHeader";
import SectionPreviewCard from "./components/SectionPreviewCard";
import SectionProfileForm from "./components/SectionProfileForm";

const Section = ({ sectionId }) => {
  const {
    finalSectionId,
    sectionData,
    formData,
    galleries,
    loading,
    saving,
    demoMode,
    completion,
    publicLinksCount,
    handleChange,
    handleQuillChange,
    handleSave,
    fetchData,
  } = useSectionProfile(sectionId);

  if (loading) {
    return (
      <section className="w-full pb-10 font-satoshi">
        <div className="mx-auto max-w-[1400px] space-y-5">
          <div className="h-40 animate-pulse rounded-[28px] bg-slate-200 dark:bg-slate-800" />
          <div className="grid gap-5 xl:grid-cols-[360px_1fr]">
            <div className="h-[520px] animate-pulse rounded-[28px] bg-slate-200 dark:bg-slate-800" />
            <div className="h-[720px] animate-pulse rounded-[28px] bg-slate-200 dark:bg-slate-800" />
          </div>
        </div>
      </section>
    );
  }

  if (!sectionData || !finalSectionId) {
    return (
      <section className="w-full pb-10 font-satoshi">
        <div className="mx-auto max-w-[1400px]">
          <div className="overflow-hidden rounded-[28px] border border-rose-200 bg-white shadow-sm dark:border-rose-500/20 dark:bg-slate-900">
            <div className="h-1.5 bg-gradient-to-r from-rose-500 to-orange-500" />

            <div className="p-5 sm:p-6">
              <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-rose-500">
                Section introuvable
              </p>

              <h1 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">
                Impossible de charger la fiche association
              </h1>

              <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                Aucune section n’est sélectionnée ou les données n’ont pas pu
                être récupérées.
              </p>
            </div>
          </div>
        </div>

        <ToastContainer position="top-right" autoClose={2500} theme="colored" />
      </section>
    );
  }

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <SectionHeader
          sectionName={formData.nom_section}
          sectionId={finalSectionId}
          loading={loading}
          saving={saving}
          demoMode={demoMode}
          onRefresh={fetchData}
          onSave={handleSave}
        />

        <div className="grid gap-5 xl:grid-cols-[380px_1fr]">
          <div className="xl:sticky xl:top-24 xl:self-start">
            <SectionPreviewCard
              formData={formData}
              completion={completion}
              publicLinksCount={publicLinksCount}
            />
          </div>

          <SectionProfileForm
            formData={formData}
            galleries={galleries}
            saving={saving}
            demoMode={demoMode}
            onChange={handleChange}
            onQuillChange={handleQuillChange}
            onSubmit={handleSave}
          />
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default Section;